import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "truncate" }
const _hoisted_2 = { class: "line-clamp-2" }

import { usePageStore } from '@/store';
import { Link, Image, RichText, Text } from '@sitecore-jss/sitecore-jss-vue';
import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'BrandBadge',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const dataTestId = usePageStore().dataTestId(props.rendering);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Link), {
    field: _ctx.fields?.NavigationUrl,
    class: _normalizeClass(["block group w-45 text-paragraph-color no-underline active:no-underline", _ctx.fields?.classes]),
    "data-test-id": _unref(dataTestId)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Image), {
        media: _ctx.fields?.Image,
        class: "rounded-lg border-[1.5px] border-racq-pale-blue mb-3 w-45 h-26.25 shadow-md group-hover:shadow-1xl group-active:shadow-none",
        width: "180",
        height: "105"
      }, null, 8, ["media"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Text), {
          field: _ctx.fields?.Title,
          class: "text-m-bold text-ellipsis group-active:underline"
        }, null, 8, ["field"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RichText), {
          field: _ctx.fields?.Content,
          class: "text-sm group-active:text-racq-med-grey"
        }, null, 8, ["field"])
      ])
    ]),
    _: 1
  }, 8, ["field", "class", "data-test-id"]))
}
}

})